import { memo } from "react";
import {
  MdOutlineHome,
  MdOutlineDashboard,
  MdOutlineSupervisedUserCircle,
  MdOutlineHistory,
  MdOutlineMonetizationOn,
  MdOutlineLaptop,
  MdOutlineBarChart,
  MdOutlineLibraryBooks,
  MdOutlineTimeline,
  MdDirectionsRun,
  MdChecklist,
  MdOutlineAirplanemodeActive,
  MdCurrencyExchange,
  MdOutlineQuestionMark,
} from "react-icons/md";
import {
  RiMoneyDollarBoxLine,
  RiUserSearchLine,
  RiUserSettingsLine,
} from "react-icons/ri";
import { FaBuilding } from "react-icons/fa";
import {
  BsGear,
  BsCheck2Circle,
  BsCalendarCheck,
  BsPersonCheck,
} from "react-icons/bs";
import {
  TbBriefcase,
  TbFileDollar,
  TbMapSearch,
  TbUsersGroup,
} from "react-icons/tb";
import { useSettingSelector } from "hooks/useSelector";
import pettyCashDark from "assets/svg/petty_cash_dark.svg";
import pettyCashWhite from "assets/svg/petty_cash_white.svg";
import managementClientDark from "assets/svg/client.svg";
import managementClientWhite from "assets/svg/client_white.svg";
import { BiBuildings } from "react-icons/bi";
import taskDark from "assets/svg/task_dark.svg";
import taskWhite from "assets/svg/task_white.svg";
import kpiDark from "assets/svg/kpi.svg";
import kpiWhite from "assets/svg/kpi_white.svg";
import kpiFormDark from "assets/svg/kpi_form.svg";
import kpiFormWhite from "assets/svg/kpi_form_white.svg";
import kpiTimelineDark from "assets/svg/kpi_timeline.svg";
import kpiTimelineWhite from "assets/svg/kpi_timeline_white.svg";
import kpiReviewDark from "assets/svg/kpi_review.svg";
import kpiReviewWhite from "assets/svg/kpi_review_white.svg";

const IconMenuItem = memo(({ name, ...props }) => {
  const settings = useSettingSelector();

  switch (name) {
    case "home":
    case "dashboard":
      return <MdOutlineHome {...props} />;
    case "employee":
      return <MdOutlineSupervisedUserCircle {...props} />;
    case "attendance":
      return <MdOutlineHistory {...props} />;
    case "work_schedule":
      return <BsCalendarCheck {...props} />;
    case "presence":
      return <BsPersonCheck {...props} />;
    case "leaves":
      return <MdOutlineAirplanemodeActive {...props} />;
    case "payroll":
    case "payroll_payment":
      return <RiMoneyDollarBoxLine {...props} />;
    case "finance":
      return <MdOutlineMonetizationOn {...props} />;
    case "inventory":
      return <MdOutlineLaptop {...props} />;
    case "company":
      return <FaBuilding {...props} />;
    case "report":
      return <MdOutlineBarChart {...props} />;
    case "accounting":
      return <MdOutlineLibraryBooks {...props} />;
    case "approval":
      return <BsCheck2Circle {...props} />;
    case "timeline":
      return <MdOutlineTimeline {...props} />;
    case "settings":
      return <BsGear {...props} />;
    case "client_visit":
      return <MdDirectionsRun {...props} />;
    case "presence_approval":
      return <MdChecklist {...props} />;
    case "cash_receipt":
      return <TbFileDollar {...props} />;
    case "reimbursement":
      return <MdCurrencyExchange {...props} />;
    case "FAQ":
      return <MdOutlineQuestionMark {...props} />;
    case "location_tracking":
      return <TbMapSearch {...props} />;
    case "recruitment":
      return <RiUserSearchLine {...props} />;
    case "recruitment_profile":
      return <BiBuildings {...props} />;
    case "recruitment_management":
      return <RiUserSettingsLine {...props} />;
    case "recruitment_job":
      return <TbBriefcase {...props} />;
    case "recruitment_candidate":
      return <TbUsersGroup {...props} />;
    case "petty_cash":
      return (
        <img
          src={settings?.dark_mode ? pettyCashWhite : pettyCashDark}
          alt="petty-cash"
          {...props}
        />
      );
    case "client":
      return (
        <img
          src={
            settings?.dark_mode ? managementClientWhite : managementClientDark
          }
          alt="management-client"
          {...props}
        />
      );
    case "task":
      return (
        <img
          src={settings?.dark_mode ? taskWhite : taskDark}
          alt="task"
          {...props}
        />
      );
    case "kpi":
      return (
        <img
          src={settings?.dark_mode ? kpiWhite : kpiDark}
          alt="kpi"
          {...props}
        />
      );
    case "kpi_form":
      return (
        <img
          src={settings?.dark_mode ? kpiFormWhite : kpiFormDark}
          alt="kpi_form"
          {...props}
        />
      );
    case "kpi_timeline":
      return (
        <img
          src={settings?.dark_mode ? kpiTimelineWhite : kpiTimelineDark}
          alt="kpi_timeline"
          {...props}
        />
      );
    case "kpi_review":
      return (
        <img
          src={settings?.dark_mode ? kpiReviewWhite : kpiReviewDark}
          alt="kpi_review"
          {...props}
        />
      );
    default:
      return <MdOutlineDashboard {...props} />;
  }
});

export default IconMenuItem;
